export const POPUP_ID = 'ConfirmMarketingPreferencesPopupID';
